import html from "./DrilldownModal.html"
import "./DrilldownModal.css"

var module = angular.module("ResearchKitApplicationModule");
module.component('drilldownModal', {
	template: html,
	bindings: {
		"eventType": "<",
		"eventData": "<"
	},
	controller: 'drilldownModalController',
	controllerAs: 'vm'
});

module.controller("drilldownModalController", ["$scope", "ceUrl",
	function ($scope, ceUrl) {
		var vm = this;
		vm.close = function () {
			vm.eventData = null;
		}
		vm.reportViewerPath = CareEv.MakePath('Authenticated/ReportViewer/ServeReport.ashx');
	}
]);
